import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import TwoColumnLayOut from "../../../layouts/two-columns/two-column-layout";
import { retrieveEducationPages } from "../../../redux/slice/education/education-pages-slice";
import { retrievePageMenu } from "../../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../../redux/store";
import { Helmet } from "react-helmet-async";
import LoadingComp from "../../../components/re-usable/loading/loading";

const CertificateInEffectiveCommunication = () => {
  const dispatch = useAppDispatch();
  const path = "Education%2FE-Learning%2FCertificate-in-Effective-Communication";
  const { eduationPagesData } = useSelector((state: RootState) => state.EducationPages);
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);

  useEffect(() => {
    dispatch(retrieveEducationPages(`%2F${path}`));
    dispatch(retrievePageMenu(`%2F${path}`));
  }, [dispatch]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
      if (RapsEuropeData[0]?.result !== undefined) {
        setIsPublished(true);
      }
    }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0].menuItemName}</title>
      </Helmet>
      <TwoColumnLayOut breadcrumbPath={path} isBreadcrumbpath={true} showAds={true}>
        <div dangerouslySetInnerHTML={{ __html: eduationPagesData[0]?.topText }}></div>
        <div></div>
        {eduationPagesData[0]?.workShopItemList?.map((item, index) => {
          return (
            <div className="info-listing-section" key={index}>
              <div className="container il-container">
                <div className="il-img-wrapper text-center col-lg-3 col-md-12">
                  <img src={item.sideImage} className="il-img" alt="" />
                </div>
                <div className="il-content-wrapper">
                  <h2 className="h2" style={{ marginTop: "unset" }}>
                    <Link to={`/events/${item.nodeName}`}>{item.eventName}</Link>
                  </h2>
                  <b>
                    <p>{item.formattedDate} </p>
                  </b>
                  <p className="il-content-intro" dangerouslySetInnerHTML={{ __html: item.shortDescription }}></p>
                </div>
                <div className="il-side-wrapper">
                  <div className="il-side"></div>
                  <div className="il-btn-wrapper">
                    <Link to={`/events/${item.nodeName}`} className="btn btn-default">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        <div dangerouslySetInnerHTML={{ __html: eduationPagesData[0]?.bottomText }}></div>
      </TwoColumnLayOut>
    </>
  );
};

export default CertificateInEffectiveCommunication;
